export const Logo = ({ className = "h-9", testId = "brand-logo" }) => (
  <svg data-testid={testId} viewBox="30 30 690 180" className={className} role="img" aria-label="Sliance AI">
    <defs>
      <linearGradient id="slIcon" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3b82f6" />
        <stop offset="50%" stopColor="#60a5fa" />
        <stop offset="100%" stopColor="#93c5fd" />
      </linearGradient>
    </defs>
    <rect x="40" y="40" width="160" height="160" rx="32" fill="url(#slIcon)" stroke="#ffffff" strokeWidth="4" />
    <text x="120" y="130" fontFamily="Arial, Helvetica, sans-serif" fontSize="80" fontWeight="bold" fill="#fff"
      textAnchor="middle" dominantBaseline="middle">S</text>
    <text x="240" y="140" fontFamily="Arial, Helvetica, sans-serif" fontSize="96" fontWeight="bold" fill="currentColor"
      dominantBaseline="middle">Sliance</text>
    <circle className="pulse-dot" cx="690" cy="60" r="10" fill="#3b82f6" />
    <text x="640" y="115" fontFamily="Arial, Helvetica, sans-serif" fontSize="60" fontWeight="600" fill="#3b82f6"
      textAnchor="middle">AI</text>
  </svg>
);
